import GraphQLClient from '../../core/adapter/graphQLClient';
import Session from '../../entity/session';
import User from '../../entity/user';
import Result from '../../entity/result';
import SignupUser from '../../entity/signupUser';
import getCurrentUserBySession from './query/getCurrentUserBySession';
import signup from './mutation/signup';
import updateUser from './mutation/updateUser';
import sendResetPassword from './mutation/sendResetPassword';
import resetPassword from './mutation/resetPassword';
import verifyEmailForUser from './mutation/verifyEmailForUser';
import resendVerifyEmailForUser from './mutation/resendVerifyEmailForUser';
import inviteByStore from './mutation/invite';

class UserRepository {
  private graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getUserBySession(session: Session): Promise<User> {
    return this.graphqlClient.query(session, getCurrentUserBySession).then(({ data }: { data: any }) => User.fromJson(data['user']));
  }

  public signup(
    token: string,
    signupUser: SignupUser,
  ) {
    return this.graphqlClient
      .mutate(null, signup, {
        variables: {
          signupUserInput: signupUser.toJson(),
          token,
        },
      })
      .then(({ data }: { data: any }) => data['signup']);
  }

  public sendResetPassword(
    email: string,
  ) {
    return this.graphqlClient
      .mutate(null, sendResetPassword, {
        variables: {
          email,
        },
      })
      .then(({ data }: { data: any }) => data['sendResetPasswordForStore']);
  }

  public resetPassword(
    token: string,
    password: string,
    passwordConfirmation: string,
  ) {
    return this.graphqlClient
      .mutate(null, resetPassword, {
        variables: {
          token,
          password,
          passwordConfirmation
        },
      })
      .then(({ data }: { data: any }) => data['resetPasswordForStore']);
  }

  public saveUser (
    session: Session,
    {
      user,
    }: {
      user: User;
    },
  ) {
    const id = user.id;
    const mutation = updateUser;
    const mutationName = 'updateUser';
    return this.graphqlClient
      .mutate(session, mutation, {
        variables: {
          user: user.toJson(),
          id: id ? id : undefined,
        },
      })
      .then(({ data }: { data: any }) => User.fromJson(data[mutationName]));
  }

  public verifyEmail (
    {
      token,
    }: {
      token: string;
    },
  ) {
    return this.graphqlClient
      .mutate(null, verifyEmailForUser, {
        variables: {
          token,
        },
      })
      .then(({ data }: { data: any }) => data['verifyEmailForUser']);
  }

  public sendVerifyEmail (
    session: Session,
    {
      user,
    }: {
      user: User;
    },
  ) {
    return this.graphqlClient
      .mutate(session, resendVerifyEmailForUser, {
        variables: {
          id: user.id,
        },
      })
      .then(({ data }: { data: any }) => data['sendVerifyEmailForUser']);
  }

  public invite (
    session: Session,
    {
      email,
    }: {
      email: string;
    },
  ) {
    return this.graphqlClient
      .mutate(session, inviteByStore, {
        variables: {
          invite: { email },
        },
      })
      .then(({ data }: { data: any }) => Result.fromJson(data['inviteByStore']));
  }
}

export default UserRepository;
